"use client";

import { Button, ButtonProps } from "@heroui/react";

export default function ClientButton(props: ButtonProps) {
  return <Button {...props} />;
}
